import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { store } from './store';
import interceptor from './services/interceptors';

// Condominium
import condominium from './utility/condominium';
import Spinner from './components/spinner';

import './assecs/scss/style.scss';

// Pages
const DashboardIndex = lazy(() => import('./pages/dashboard/index'));
const DashboardLogin = lazy(() => import('./pages/dashboard/login'));
const DriverIndex = lazy(() => import('./pages/driver/index'));
const DriverLogin = lazy(() => import('./pages/driver/login'));
const Substitute = lazy(() => import('./pages/mobile/substitute'));
const Build = lazy(() => import('./pages/mobile/build'));
const Checkout = lazy(() => import('./pages/mobile/checkout'));
const Condition = lazy(() => import('./pages/mobile/condition'));
const Reserve = lazy(() => import('./pages/mobile/reserve'));
const Reset = lazy(() => import('./pages/reset'));
const Index = lazy(() => import('./pages/index'));
const ErrorPage = lazy(() => import('./pages/mobile/error'));
const CardBinding = lazy(() => import('./pages/mobile/card-binding'));
const Pay3DS = lazy(() => import('./pages/mobile/pay-3ds'));

// Components
const Alerts = lazy(() => import('./components/alerts'));

const App = () => {	
	const type = useSelector(state => state.model.type);
	const { _switch } = useSelector(state => state.spinner);
	
	return (
		<BrowserRouter>
			<Suspense fallback={ <Spinner /> }>
				<Routes>
					<Route exact path="/" element={ <Index /> } />
					<Route exact path="/dashboard/login" name="Dashboard login page" element={<DashboardLogin />} />
					<Route exact path="/driver/login" name="Driver login page" element={<DriverLogin />} />
					<Route exact path="/reset" name="Reset password page" element={<Reset />} />
					<Route path="/dashboard/*" element={ <DashboardIndex /> } />
					<Route path="/driver/*" element={ <DriverIndex /> } />
					<Route path="/substitute-driver" element={ <Substitute /> } />
					<Route path="/build-detailed" element={ <Build /> } />
					<Route path="/checkout-detailed" element={ <Checkout /> } />
					<Route path="/car-condition" element={ <Condition /> } />
					<Route path="/reserve" element={ <Reserve /> } />
					<Route path="/card-binding-success" element={ <CardBinding isSuccess /> } />
					<Route path="/card-binding-failure" element={ <CardBinding /> } />
					<Route path="/pay-3ds" element={ <Pay3DS /> } />
					<Route path="/error-page" element={ <ErrorPage /> } />
				</Routes>
				{ _switch && <Spinner /> }
				{ condominium[type] }
				<Alerts />
			</Suspense>
		</BrowserRouter>
	)
};

interceptor(store);
  
export default App;
